// 路径管理
import http from "@/jslibs/axios/http";

// 新增路径
export const add = (data) => http.post("/cms/path/add", data);

// 编辑路径
export const edit = (data) => http.post("/cms/path/update", data);

// 路径详情
export const detail = (id) => http.get("/cms/path/details/" + id);

// 路径分页列表
export const page = (data) => http.get("/cms/path/page", data);

// 路径删除
export const del = (id) => http.delete("/cms/path/delete/" + id);